import Input from '@/components/form/Input';
import Select from '@/components/form/Select';
import { FEE_TYPE } from '../../enums';

const getFeeTypeOptions = () => {
  return [
    { label: FEE_TYPE.PERCENTAGE, value: FEE_TYPE.PERCENTAGE },
    { label: FEE_TYPE.FLAT_FEE, value: FEE_TYPE.FLAT_FEE }
  ];
};

const FormGeneral = () => {
  return (
    <>
      <Input
        name="label"
        label="Label"
        placeholder="e.g. Platform Fee"
        autoComplete="off"
      />
      <Input
        name="value"
        label="Value"
        placeholder="e.g. 2.9"
        autoComplete="off"
      />
      <Select name="type" label="Type" options={getFeeTypeOptions()} />
    </>
  );
};

export default FormGeneral;
